import { render, staticRenderFns } from "./CoachPlayersCertificationRow.vue?vue&type=template&id=339b2dbc&"
import script from "./CoachPlayersCertificationRow.vue?vue&type=script&lang=ts&"
export * from "./CoachPlayersCertificationRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports